import React, { useState, useContext, useEffect, useRef } from "react";
import { Oval } from "react-loader-spinner";

import { ContextGlobal } from "../../../contexts/ContextGlobal";

export const SaveButton = (props) => {
    const { session, updateUser, updateRequest, verifyEmail, createCode, login } = useContext(ContextGlobal);

    const [message, setMessage] = useState(null);
    const [loading, setLoading] = useState(false);
    const [guestMsg, setGuestMsg] = useState("");
    const [savedMsg, setSavedMsg] = useState("");

    useEffect(() => {
        if (session.email) {
            setMessage("Want to save your changes? Click on save draft below.");
        } else {
            setMessage("**Want to save your changes? Fill in Your Info above and click the save button below. An account will be created for you if you don't have one already.");
        }
    }, [session]);

    const saveSubmit = async () => {
        setLoading(true);
        if (session.email) {
            // logged in user
            // 1. save all data
            const response = await updateRequest(false, false);
            if(response) {
                const currentDateTime = new Date().toLocaleString();
                setSavedMsg(`Your changes have been saved. (${currentDateTime})`);
            } else {
                setSavedMsg("There was an error saving your changes. Please try again.");
            }
        } else {
            // guest user
            // 1. save user data
            // 2. save request data
            // 3. log user in (NOT)
            props.methods.clearErrors();

            const userFirstName = props.methods.trigger("userFirstName");
            const userLastName = props.methods.trigger("userLastName");
            const email = await props.methods.trigger("email");
            if (userFirstName && userLastName && email) {
                // check if user exists??
                const verify = await verifyEmail({email: props.methods.getValues("email")});
                // user does not exist then we udpate the user
                if (!verify.success) {
                    // update guest user data
                    await updateUser({
                        firstName: props.methods.getValues("userFirstName"),
                        lastName: props.methods.getValues("userLastName"),
                        email: props.methods.getValues("email"),
                        phone: props.methods.getValues("phoneNumber"),
                        lawFirm: props.methods.getValues("lawFirm"),
                    })
                }

                // save request data
                const response = await updateRequest(false, false);
                if(response) {
                    const currentDateTime = new Date().toLocaleString();
                    setMessage("");
                    setSavedMsg(`Your changes have been saved. (${currentDateTime})`);
                    if (!verify.success) {
                        // display message to guest user - new account created
                        setGuestMsg(
                            <>
                                An account has been created for you. You'll be able to see your draft next time you log in under <a href="/my_reports" style={{ textDecoration: "none", color: "#1db8ea" }}>My Reports</a>. You can log in with the email you provided above and by choosing the 'Sign in with code' option. A code will be sent to your email.
                            </>
                        );
                    }
                } else {
                    setSavedMsg("There was an error saving your changes. Please try again.");
                }
                // TODO: Discuss signing in user...
                // const code = await createCode({
                //     email: props.methods.getValues("email"),
                //     newUser: true,
                // });

                // await login({
                //     email: props.methods.getValues("email"),
                //     code: code.code, // YOU NEED TO GET THIS CODE SOMEHOW, MAYBE WE WILL NEED TO GENERATE A CODE FOR THE USER FIRST
                // });
            }
        }
        setLoading(false);
        return true;
    }

    return (
        <div className="my-5 ms-4">
            <span style={{fontSize: "18px"}}>{message}</span>
            {guestMsg && <div className="mt-1 pt-2 alert alert-warning">{guestMsg}</div>}
            <div className="flex justify-center items-center mt-2">
                <button
                    type="button"
                    className="btn access-secondary-button"
                    onClick={() => {
                        saveSubmit();
                    }}
                >
                    {loading ? <Oval color="#000046" secondaryColor="white" height={20} width={20} /> : "Save Draft"}{" "}
                </button>
                {savedMsg && <span className="text-sm" style={{ marginLeft: "1rem", fontWeight: "bold" }}>{savedMsg}</span>}
            </div>
        </div>
    );
}
